<script setup>
import TabItem from "@/components/tabs/TabItem.vue";
import TabContainer from "@/components/tabs/TabContainer.vue";
import {computed} from "vue";
import {useStore} from "vuex";

const store = useStore();
const activeTab = computed(() => store.getters['actions/activeTab']);

const tabs = [
  {
    key: 'active',
    text: 'This month\'s actions',
    icon: 'new-star',
  },
  {
    key: 'page',
    text: 'Page',
    icon: 'pages',
  },
  {
    key: 'category',
    text: 'Category',
    icon: 'four-squares',
  },
  {
    key: 'completed',
    text: 'Completed',
    icon: 'tick-thin',
  },
]
</script>

<template>
  <TabContainer>
    <TabItem
      v-for="{key, text, icon} in tabs"
      :key="key"
      :active="activeTab === key"
      class="tw-flex tw-items-center tw-justify-center tw-gap-3"
      @click="store.dispatch('actions/setActiveTab', key)"
    >
      <svg-vue
        :icon="`icons/${icon}`"
        class="tw-w-6 tw-h-6"
        :class="{'tw-text-grey': activeTab === key}"
      />
      <span class="tw-font-bold">{{ text }}</span>
    </TabItem>
  </TabContainer>
</template>
